import { __extends } from "tslib";
var NoGetDefaultValueSpecified = /** @class */ (function (_super) {
    __extends(NoGetDefaultValueSpecified, _super);
    function NoGetDefaultValueSpecified(key) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nYou are calling `getDefaultValue` for styles param, but it wasn't specified.\nPlease check the `" + key + "` style param implementation.\n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NoGetDefaultValueSpecified;
}(Error));
export { NoGetDefaultValueSpecified };
//# sourceMappingURL=NoGetDefaultValueSpecified.js.map